import { cn } from "@shared/src/utils/cn";
import { VariantProps, cva } from "class-variance-authority";
import React from "react";

const chipVariants = cva("flex items-center gap-1 text-text-secondary text-xs  font-bold rounded-lg px-2 py-2", {
  variants: {
    variant: {
      default: "bg-surfaces-bg-secondary",
      primary: "bg-surfaces-bg-primary",
      brand: "bg-button-primary-bg text-neutral-100",
      secondary: "bg-surfaces-bg-secondary",
      success: "bg-button-success-bg text-neutral-100",
      warning: "bg-surfaces-bg-warning  ",
      error: "bg-surfaces-bg-error ",
    },
    fill: {
      solid: "bg-opacity-100",
      outline: "bg-transparent border border-border-secondary",
      ghost: "bg-transparent",
    },
    size: {
      xs: "px-1.5 py-0.1",
      sm: "px-2 py-0.5",
      md: "px-3 py-1.5",
      lg: "px-3 py-1.5 text-md ",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    fill: "solid",
  },
});

export interface ChipProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof chipVariants> {
  count?: number | string;
  icon?: string;
  iconAlt?: string;
  iconSize?: number;
  gap?: string;
}

export function Chip({
  className,
  variant,
  size,
  fill,
  count,
  icon,
  iconAlt,
  // iconSize = 12,
  gap = "gap-1",
  children,
  ...props
}: ChipProps) {
  const iconSize = 12;
  return (
    <div className={cn(chipVariants({ variant, size, fill }), gap, className)} {...props}>
      {icon && <img src={icon} alt={iconAlt || "icon"} width={iconSize} height={iconSize} />}
      {children || count}
    </div>
  );
}
